(function($){
    var $ = jQuery = $;
    var is_visible = true;
  //PRODUCT PAGE
    if (window.location.href.indexOf("/products/") > -1) {
      
        $(window).scroll(function() {
          var top_of_element = $("button.add-to-cart").offset().top;
          var bottom_of_element = $("button.add-to-cart").offset().top + $("button.add-to-cart").outerHeight();
          if($("button.tdf_normal_btn").length){
            var bundle_bottom_of_element = $("button.tdf_normal_btn").offset().top + $("button.tdf_normal_btn").outerHeight();
          }
          
          var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();
      
          //if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
          if (top_of_screen < bottom_of_element || top_of_screen < bundle_bottom_of_element){
              // the element is visible, do something
              $('.sticky__AddToCart').fadeOut();
              
          } 
          else {
            //console.log(is_visible);
            //console.log('not visible');
            if($('.product-single__meta.main__form .product-single__title')[0]) {
              var prod_title = $('.product-single__meta.main__form .product-single__title')[0].outerHTML;
            }
            
            if ($('.product-single__meta.main__form .product__price.on-sale')[0]) {
              var prod_price_on_sale = $('.product-single__meta.main__form .product__price.on-sale')[0].outerHTML;
            }
            else {
              var prod_price_on_sale = '';
            }
            if($('.product-single__meta.main__form .product__price')[0]) {
              var prod_price = $('.product-single__meta.main__form .product__price')[0].outerHTML;
            }
            let prod_price_group = '<div class="prod_price"/>' + prod_price + prod_price_on_sale  + '</div>';
            if ($('.product-single__meta.main__form .product__price-savings')[0]) {
              var prod_save = '<div class="prod_savings"/>' + $('.product-single__meta.main__form .product__price-savings')[0].outerHTML + '</div>';
            }
            else {
              var prod_save = '';
            }
            if ($('.product-single__meta.main__form .add-to-cart')) {
              let add_to_cart_btn = $('.product-single__meta.main__form .add-to-cart');
              let bundle_add_to_cart_btn = $('.tdf_normal_btn');
                if (is_visible) {
                  // the element is not visible, do something else
                    $('.transition-body').addClass('position-relative');
                    if(bundle_add_to_cart_btn.length){
                      var sticky_addToCart = $('<button class="btn"/>').text('Add To Cart').click(function () { bundle_add_to_cart_btn.click(); });
                    }
                    else if(add_to_cart_btn[0]) {
                    
                      if (add_to_cart_btn[0].disabled) {
                        var sticky_addToCart = $('<button class="btn"/>').prop('disabled', true).text('Sold Out');
                      }
                      else {
                        var sticky_addToCart = $('<button class="btn"/>').text('Add To Cart').click(function () { add_to_cart_btn.click(); });
                      }
                    }
                    var sticky_content = $('<div class="prod_details"/>').html('<div class="prod_price_group"/>' + prod_price_group + prod_save + '</div>').append(sticky_addToCart);
                    $('#MainContent').before($('<div class="sticky__AddToCart"/>').html(sticky_content).prepend(prod_title));
                    $('.sticky__AddToCart').slideDown();
                    is_visible = false;
                }
                else{
                  $('.sticky__AddToCart').slideDown();
                }
          } 
        }
      });
      $(window).on('load', function(){
        if($('.tdf_normal_btn').length == 0) {
          $('.main__form .product-single__form').css('display', 'block');
        }
        if(window.location.href.indexOf('#notifyme') > -1) {
          $('a.btn.btn--full.klaviyo-bis-trigger')[0].click();
        }
      });
      var urlPath = window.location.pathname.replace('%C2%A9','').split("/products/");
      shopPromotions.forEach(function(promo){
        if(promo.promo_collection_products.indexOf(urlPath[1]) > -1 ){
          $('.script-sale--custom-product').show();
          $('.product__price').hide();
          $('.sale-script--price').show();
          $('.sale-script--price .product__price').show();
        }
        
      })
      
    
    }
  //COLLECTION PAGE
    if (window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("/products/") < 0) {

      function SectionUpdate() {
        let activeCollection = window.location.href.split( '/' )[4].split('?')[0];
        
        $('.blog__section').each(function(){
          if (!$(this).hasClass('hide')) {
            $(this).addClass('hide');
          }
        });

        $('.promo-grid div.flex-grid__item[class*="type-"]').each(function(){
          if (!$(this).hasClass('hide') && $(this).attr('id') != '') {
            $(this).addClass('hide');
          }
        });

        $.get("/collections/" + activeCollection + ".json" , function(data){
          $('#shopify-section-collection-header .section-header__title').text(data.collection.title);
        });
        $('.footer-promotions #' + activeCollection).removeClass("hide").show();
        console.log($('.promo-grid #' + activeCollection));
        $('.promo-grid #' + activeCollection).removeClass("hide").show();
        //activeCollection = activeCollection.replace(/-/g, " ");
        //$('#shopify-section-collection-header .section-header__title').text(activeCollection);
        
      }

      function renderPREEZIE() {
        //PREEZIE COLLECTION PAGE
        if (window.location.href.indexOf(".com") > -1) {
          var new_url = location.href;
          var KNIFE_SET = '29e09a1b-43a5-4d3d-be39-08d8c0c9f622',
              CHEF = 'daf57127-baa6-4f93-be3b-08d8c0c9f622',
              BREAD = 'b35a871d-8c70-4070-be3c-08d8c0c9f622',
              CLEAVER = '1c6ebc44-78dc-4edf-be3d-08d8c0c9f622',
              PARING = 'c8d9ea49-b8e4-4916-be3e-08d8c0c9f622',
              FILLET = '47b36f8d-dc1b-402c-be3f-08d8c0c9f622',
              SLICING_CARVING = '4ab25b4e-a0fb-4216-be40-08d8c0c9f622',
              JAPANESE_STYLE = '85ce2d21-3b91-4ffe-be41-08d8c0c9f622',
              BONING = 'f7b3d802-7479-4594-be42-08d8c0c9f622',
              BUTCHER = '7eb2c7b2-9857-4e78-be43-08d8c0c9f622',
              UTILITY = 'd292fb07-774b-43ad-be3a-08d8c0c9f622',
              NAKIRI = 'ce3373e8-5106-459e-8d4a-08d92b8934dc',
              KIRITSUKE = '41dede5f-d49c-416b-8d4b-08d92b8934dc',
              COOKWARE = '52392c44-b1a8-4de0-c497-08d94c3c2df4';
          var PREEZIE = 'PRE-6465dfad-c1d1-4e48-9edc-08d8c0ecd403';

          if (new_url.indexOf("/block-sets") > -1) {
            PREEZIE = KNIFE_SET;
          }
          if (new_url.indexOf("/chefs-") > -1) {
            PREEZIE = CHEF;
          }
          if (new_url.indexOf("/bread-") > -1) {
            PREEZIE = BREAD;
          }
          if (new_url.indexOf("/cleaver-") > -1) {
            PREEZIE = CLEAVER;
          }
          if (new_url.indexOf("/paring-") > -1) {
            PREEZIE = PARING;
          }
          if (new_url.indexOf("/filet-") > -1) {
            PREEZIE = FILLET;
          }
          if (new_url.indexOf("/slicers") > -1 || new_url.indexOf("/brisket-knives") > -1) {
            PREEZIE = SLICING_CARVING;
          }
          if (new_url.indexOf("/japanese-") > -1) {
            PREEZIE = JAPANESE_STYLE;
          }
          if (new_url.indexOf("/boning-") > -1) {
            PREEZIE = BONING;
          }
          if (new_url.indexOf("/butcher-") > -1) {
            PREEZIE = BUTCHER;
          }
          if (new_url.indexOf("cleaver-") > -1) {
            PREEZIE = CLEAVER;
          }
          if (new_url.indexOf("/utility-") > -1) {
            PREEZIE = UTILITY;
          }
          if (new_url.indexOf("/nakiri-") > -1) {
            PREEZIE = NAKIRI;
          }
          if (new_url.indexOf("/kiritsuke") > -1) {
            PREEZIE = KIRITSUKE;
          }
          var  cookware_page = false;
          cookware.forEach(function(value){
            if (new_url.indexOf(value) > -1) {
              cookware_page = true;
            }
          })
          var  non_knives_page = false;
          non_knives.forEach(function(value){
            if (new_url.indexOf(value) > -1) {
              non_knives_page = true;
            }
          })
          
          if(!non_knives_page && !cookware_page) {
            PREEZIE_GUIDE.render([
              {
                guideKey: PREEZIE,
                version: '1.0.0',
                renderTo: 'preezie-widget-div-id'
              }
            ]);  
          }
          else if(cookware_page) {
            PREEZIE_GUIDE.render([
              {
                guideKey: COOKWARE,
                version: '1.0.0',
                renderTo: 'preezie-widget-div-id'
              }
            ]);  
          }

        } 
      }
      $(document).ready(function() {
          SectionUpdate();
      });
      //PREEZIE
      var cookware = ['-cookware', '/skillet', '/saute-pan', '/stock-pot', '/avalon-series', '/oberon-series', '/frying-pan' ];
      var non_knives = ['/cutting-boards', '/aprons', '/culinary-tools', '/whetstones', '/honing-rods', '/knife-roll', '/knife-bag', '/blocks-and-stands'];
      
      renderPREEZIE();
      
      let click_count = 0;
      let lastUrl = location.href; 
      new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
          lastUrl = url;
          onUrlChange();
        }
      }).observe(document, {subtree: true, childList: true});
      
      function addProductRatings(src) {
        setTimeout(function(){
          $('script[src="' + src + '"]').remove();
          $('<script>').attr('src', src).appendTo('head');
        }, 1000);
      }
        
      function onUrlChange() {
        SectionUpdate();
        renderPREEZIE();
        if (window.location.href.indexOf(".com") > -1) {
          addProductRatings('https://cdn.opinew.com/shop-widgets/static/js/index.3c97cee4.js');
        }
        if(click_count < 1){
          setTimeout(function(){renderPREEZIE();}, 1500);
          click_count++;
        }
        
      }
      $(window).on('load', function(){
        $('.promo-grid').show();
        
      });
    }
  // Progress bars
    $(document).ready(function() {
      $('.progress .progress-bar').css("width",
        function() {
            return ($(this).attr("aria-valuenow") / $(this).attr("aria-valuemax")) * 100 + "%";
        }
      )
    });

  //Smooth Scroll
    $(document).ready(function(){
    // Add smooth scrolling to all links
      $(".smooth_scroll").on('click', function(event) {
    
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          // Prevent default anchor click behavior
          event.preventDefault();
    
          // Store hash
          var hash = this.hash;
    
          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          $('html, body').animate({
            scrollTop: $(hash).offset().top - 100
          }, 800, function(){
    
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
        } // End if
      });
    });

  //COUNTRY SELECTOR TOP BAR
    $('#showCountrySelector').on('click', function(){
      $("#switchLocation.modal").fadeIn();
    });
    $('.mobile-menu #showCountrySelector').on('click', function(){
      $("#switchLocation.modal").fadeIn();
    });
    $("#switchLocation .adl-close").on('click', function(){
      $("#switchLocation.modal").fadeOut();
    });
    $(window).on('click', function(event) {
      if (event.target == $("div#switchLocation.modal")[0]) {
        $("#switchLocation.modal").fadeOut();
      }
    });
  
  //COMPARE PAGE & COMPARE SECTION
    if (window.location.href.indexOf("/products/") > -1 || window.location.href.indexOf('pages/compare') > -1) {
      function infoRenderer (text, img) {
        return (
          (img == null ? '' : '<img class="feat_icon" src="'  + img + '" >') +
          (text == null ? '<p>-</p>' : '<p>' + text + '</p>')
        )
      }
      function renderProduct(data, targetColumn) {
        var isProductPage = false;
        if (window.location.href.indexOf("/products/") > -1) {
          isProductPage = true;
        }
        var productMeta = JSON.parse(data);
        var productTitle = productMeta.product.title.replace(/"/g, "&quot;");
            productTitle = productTitle.replace(/'/g, "&#039;");
        if(isProductPage && targetColumn == '.column--0') {
          $('.image' + targetColumn).html('<img class="lazyload" data-src="'+ productMeta.product.image +'" alt="' + productMeta.product.title + '">'+
                          '<h4>' + productMeta.product.title + '</h4>'); 
        }
        else {
          if(!isProductPage){
            fetch('/products/' + productMeta.product.link.replace('/products/', '') + '.js')
            .then(res => res.json())
            .then((data_product) => {
              console.log(data_product);
              $('.image' + targetColumn).addClass('product-section');
              $('.image' + targetColumn).attr({
                'data-product-url': data_product.url,
                'data-product-handle' : data_product.handle,
                'data-section-type': 'product-template',
                'data-section-id' : data_product.id
              });
              
              var itemFirstVariantId = '';
              if (data_product.has_only_default_variant) {
                itemFirstVariantId = data_product.variant.id;
              }
              else{
                data_product.variants.forEach(function (variant) { 
                  itemFirstVariantId = variant.id;
                });
              }
              var addToCartBtn = '';
              if(data_product.available) {
                addToCartBtn = '<button type="submit" name="add" id="AddToCart-' + data_product.id + '" class="btn btn--full add-to-cart" aria-expanded="false">' +
                '<span id="AddToCartText-' + data_product.id + '" data-default-text="">Add to cart</span></button>';
              }
              else {
                addToCartBtn = '<button type="submit" name="add" id="AddToCart-' + data_product.id + '" class="btn btn--full add-to-cart" aria-expanded="false" disabled="disabled">' +
                '<span id="AddToCartText-' + data_product.id + '" data-default-text="">SOLD OUT</span></button>';
              }
              $('.image' + targetColumn).html('<a class="image-link" href="' + data_product.url + '"><img class="lazyload" data-src="'+ data_product.featured_image +'" alt="' + data_product.title + '"></a>'+
              '<a class="image-link product-title" href="' + data_product.url + '"><h4>' + data_product.title + '</h4></a>' + '<form method="post" action="/cart/add" id="AddToCartForm-' + data_product.id + '" accept-charset="UTF-8" class="product-single__form" enctype="multipart/form-data">' +
              '<input type="hidden" name="form_type" value="product">' + 
              '<input type="hidden" name="utf8" value="✓">' + 
              '<input type="hidden" name="id" value="' + itemFirstVariantId + '">' + addToCartBtn + '</form>' + 
              '<button class="btn btn--secondary btn--small compare__modal-changeBtn" data-product="' + data_product.url + '" data-title="' + productTitle + '">Change</button>');
            });
          }
          else {
            $('.image' + targetColumn).html('<a class="image-link" href="' + productMeta.product.link + '"><img class="lazyload" data-src="'+ productMeta.product.image +'" alt="' + productMeta.product.title + '"></a>'+
            '<a class="image-link product-title" href="' + productMeta.product.link + '"><h4>' + productMeta.product.title + '</h4></a> <button class="btn btn--secondary btn--small compare__modal-changeBtn" data-product="' + 
            productMeta.product.link + '" data-title="' + productTitle + '">Change</button>' +
            '<a href="' + productMeta.product.link + '" class="btn btn--secondary btn--small">Learn More</a>');  
          }
        }
        $('.Steel' + targetColumn).html(
          infoRenderer(productMeta.metafields.Steel, productMeta.metafields.Steel_Icon)
        );
        $('.steel_thikness' + targetColumn).html(
          infoRenderer(productMeta.metafields.Steel_Thickness, productMeta.metafields.Steel_Thickness_Icon)
        );
        $('.Handle' + targetColumn).html(
            infoRenderer(productMeta.metafields.Handle, productMeta.metafields.Handle_Icon)
        ); 
        $('.knife_weight' + targetColumn).html(
            infoRenderer(productMeta.metafields.Knife_Weight, productMeta.metafields.Knife_Weight_Icon)
        );
        $('.Blade-Angle' + targetColumn).html(
            infoRenderer(productMeta.metafields.Blade_Angle, productMeta.metafields.Blade_Angle_Icon)
        );
        $('.Rockwell' + targetColumn).html(
            infoRenderer(productMeta.metafields.Rockwell, productMeta.metafields.Rockwell_Icon)
        );
        $('.special_feature' + targetColumn).html(
            infoRenderer(productMeta.metafields.Special_Feature, productMeta.metafields.Special_Feature_Icon)
        );
        $('.who-is' + targetColumn).html(
            infoRenderer(productMeta.metafields.Who_Is_This_Knife_For, productMeta.metafields.Who_Is_This_Knife_For_Icon)
        );
        $('.Packaging-Components  + targetColumnp').html(productMeta.metafields.Packaging_Components == null ? '-' : productMeta.metafields.Packaging_Components); 
        
      }
      function ctaButtons() {
        setTimeout(function(){
          $(".compare__modal-changeBtn").each(function(index) {
            $(this).on('click', function() {
              // $('.productList__Item .btn.compare').addClass()
              $('.compare__modal-footer #selected-product').html($(this).data('title'));
              $("#compare__myModal").removeClass('column-0 column-1 column-2');
              $("#compare__myModal").addClass('column-'+ index);
              openKnifeSelector();
            });
          });
          if (theme.settings.cartType === 'drawer') {
            $('.product-section').each(function() {
              var sectionId = $(this).attr('data-section-id');
                new theme.AjaxProduct($('#AddToCartForm-' + sectionId));
            })
          }
        }, 1000);
      }
      //SET COMPARE DATA VARIABLES
      var compareData = JSON.parse(localStorage.getItem('compare__products'));
      var recentlyViewedProduct = JSON.parse(localStorage.getItem('nf_recent_v'));
      var compare__products = ['ss-x-8-in-chef', 'gs-8-in-chef'];
      var urlPath = window.location.pathname.split("/products/");

      // Get the modal
      var modal = $("#compare__myModal");
      // Get the <span> element that closes the modal
      var close = $(".compare__modal-close");
      function openKnifeSelector() {
        var compareData = JSON.parse(localStorage.getItem('compare__products'));
        $('.productList__Item').each(function(){
          $(this).removeClass('selected-product');
          $(this).find('.btn.compare-product').attr({'disabled': false}).html('Compare <span>+</span>');
          for(let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {
            if(compareData[compareDataItem] == $(this).data('product')){
              $(this).addClass('selected-product');
              $(this).find('.btn.compare-product').attr({'disabled': true}).html('Selected');
              
            }
          }
          $("#compare__myModal").fadeIn(500);
        });
      }
      // When the user clicks on <span> (x), close the modal
      close.on('click', function() {
        $("#compare__myModal").removeClass('column-0 column-1 column-2');
        modal.fadeOut(300);
      })

      // When the user clicks anywhere outside of the modal, close it
      $(window).on('click', function(event) {
        if (event.target == modal[0]) {
          close.click();
        }
      });
      
      //SEARCH BAR
      $('#searchProduct').keyup(function(){
        $('#knife_series').prop("selectedIndex", 0);
        $('#knife_type').prop("selectedIndex", 0);
        var input, filter,productList,productList__Item, a, i, txtValue;
        input = document.getElementById('searchProduct');
        filter = input.value.toUpperCase();
        productList = document.getElementById("productList");
        productList__Item = document.querySelectorAll('.productList__Item');
        // Loop through all List items, and hide those who don't match the search query
        for (i = 0; i < productList__Item.length; i++) {
          a = productList__Item[i].getElementsByTagName("p")[0];
          txtValue = a.textContent || a.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
          $(productList__Item[i]).fadeIn(300);
          } else {
            $(productList__Item[i]).fadeOut(300);
          }
        }
      });
      //FILTER BAR 
      $('#knife_series').on('change', function() {
        $('#knife_type').prop("selectedIndex", 0);
        $('#searchProduct').val('');
        filterSelection($(this).val());
      });
      $('#knife_type').on('change', function() {
        $('#knife_series').prop("selectedIndex", 0);
        $('#searchProduct').val('');
        filterSelection($(this).val());
      });
      function filterSelection(c) {
        var x;
        x = document.getElementsByClassName("productList__Item");
        if (c == "all") c = "";
        $('.productList__Item').each(function(){
          $(this).fadeOut(300);
          if($(this)[0].className.toLowerCase().indexOf(c) > -1) {
            $(this).fadeIn(300);
          }
        });
      }
      //COMPARE SELECT BUTTON CLICK
      $(".btn.compare-product").each(function() {
        $(this).on('click', function() {
          // $('.productList__Item .btn.compare').addClass()
            var columnNumber;
            if($('#compare__myModal').hasClass('column-0')) {
              columnNumber = 0;
            }
            else if($('#compare__myModal').hasClass('column-1')) {
              columnNumber = 1;
            }
            else if($('#compare__myModal').hasClass('column-2')) {  
              columnNumber = 2;
            }
            //Update Compare Product
            if(window.location.href.indexOf("/products/") > -1) {columnNumber++;}

            $.get('/products/' + $(this).data('product') + '/metafields?view=json', function(data) { renderProduct(data, '.column--' + columnNumber); });
            ctaButtons();
            //Save Data
            var compareData = JSON.parse(localStorage.getItem('compare__products'));
            if(compareData) {
              var newCompareData = compareData;
              newCompareData[columnNumber] = $(this).data('product');
              localStorage.setItem("compare__products", JSON.stringify(newCompareData));
            }
            //Colse Modal
            close.click();
        });
      });
      //STICKY IMAGE SECTION
      $(window).scroll(function() {
        if($(".compare-section").length > 0){
          var top_of_element = $(".compare-section").offset().top - 100;
          //var bottom_of_element = $(".compare-section").offset().top + $(".compare-section").outerHeight();
          //var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
          var top_of_screen = $(window).scrollTop();
          //if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
          if (top_of_screen < top_of_element){
              // the element is visible, do something
              $('#imageSection').removeClass('sticky--section');
          } 
          if (top_of_screen > top_of_element) {
            $('#imageSection').addClass('sticky--section');
          } 
        }
      });
      $(window).on('load', function() {
        ctaButtons();
      });
    }

  //PRODUCT PAGE COMPARE SECTION
    if (window.location.href.indexOf("/products/") > -1 && $(".compare-section").length > 0) {
      if(compareData) {
        var dataExist = true;
        var loopCounter = 1;
        for(let compareDataItem = 0; compareDataItem <= compareData.length; compareDataItem++) {
          if(compareData[compareDataItem] == urlPath[1]){
            dataExist = false;
          }
          else if(compareData[compareDataItem] != urlPath[1] && loopCounter < 3) {
            $.get('/products/' + compareData[compareDataItem] + '/metafields?view=json', function(data) { renderProduct(data, '.column--' + loopCounter ); loopCounter++;});
          }
        }
        if(dataExist) {
          var newCompareData = compareData;
          if(compareData.length > 2){
            newCompareData[2] = compareData[1];
            
          }
          newCompareData[1] = compareData[0];
          newCompareData[0] = urlPath[1];
        
          
          localStorage.setItem("compare__products", JSON.stringify(newCompareData));
          
        }
      }
      //if no compare data look for recently viewed products
      else {
        if( urlPath[1] == compare__products[0]) {
          $.get('/products/' + compare__products[1] + '/metafields?view=json', function(data) { renderProduct(data, '.column--1'); });
        }
        else if( urlPath[1] == compare__products[1]){
          $.get('/products/' + compare__products[0] + 'metafields?view=json', function(data) { renderProduct(data, '.column--1'); });
        }
        else {
          $.get('/products/' + compare__products[0] + '/metafields?view=json', function(data) { renderProduct(data, '.column--1'); });
          $.get('/products/' + compare__products[1] + '/metafields?view=json', function(data) { renderProduct(data, '.column--2'); });
          compare__products.push(compare__products[1]);
          compare__products[1] = compare__products[0];
          compare__products[0] = urlPath[1];
        }
        localStorage.setItem("compare__products", JSON.stringify(compare__products));
      }
      //LOAD COMPARE SECTION FIRST COLUMN
      $.get('/products/' + urlPath[1] + '/metafields?view=json', function(data) { renderProduct(data, '.column--0');});
    }

  //COMPARE PAGE
    if (window.location.href.indexOf('pages/compare') > -1) {
      //has a saved compare data
      if(compareData) {
        for(let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {
          $.get('/products/' + compareData[compareDataItem] + '/metafields?view=json', function(data) { renderProduct(data, '.column--' + compareDataItem);});
        }
      }
      //if no compare data look for recently viewed products
      else if(recentlyViewedProduct){
        var newCompareData = compare__products;
        for (let i = 0; i < 2; i++) {
          if(recentlyViewedProduct.i.length == 1){
            if(i == 0) {
              $.get('/products/'+ recentlyViewedProduct.i[i].h +'/metafields?view=json', function(data) { renderProduct(data, '.column--' + i); });
              newCompareData[0] = recentlyViewedProduct.i[i].h;
            }
            if(i==1) {
              if(recentlyViewedProduct.i[0].h == compare__products[0]) {
                $.get('/products/' + compare__products[1] + '/metafields?view=json', function(data) { renderProduct(data, '.column--' + i); });
                newCompareData[1] = compare__products[1];
              }
              else if(recentlyViewedProduct.i[0].h == compare__products[1] || recentlyViewedProduct.i[0].h != 'ss-x-8-in-chef'){
                $.get('/products/' + compare__products[0] + 'metafields?view=json', function(data) { renderProduct(data, '.column--' + i); });
                newCompareData[1] = compare__products[0];
              }
            }
            
          }
          else {
              $.get('/products/'+ recentlyViewedProduct.i[i].h +'/metafields?view=json', function(data) { renderProduct(data, '.column--' + i); });
              newCompareData[i] = recentlyViewedProduct.i[i].h;
          }
        }
        localStorage.setItem("compare__products", JSON.stringify(newCompareData));
      }
      //if no compare data and recently viewed products load default products
      else {
        localStorage.setItem("compare__products", JSON.stringify(compare__products));
        compareData = JSON.parse(localStorage.getItem('compare__products'));
        for(let compareDataItem = 0; compareDataItem < compareData.length; compareDataItem++) {
          $.get('/products/' + compareData[compareDataItem] + '/metafields?view=json', function(data) { renderProduct(data, '.column--' + compareDataItem);});
        }
      }
    }

  //BLOG PAGE - INFINITE SCROLL
    if (window.location.href.indexOf('/blogs/news') > -1 && window.location.href.indexOf('/blogs/news/') < 0) {
      document.addEventListener("DOMContentLoaded", function() {
        var endlessScroll = new Ajaxinate({
          container: '#AjaxinateLoop',
          pagination: '#AjaxinatePagination',
          method: 'click'
        });
      });
    }

  //SWIPER CAROUSEL
      $(window).on('load', function(){
        $('#shopify-section-blog-related-articles').show();
        const swiper = new Swiper('.swiper', {
          // Optional parameters
          slidesPerView: 5,
          slidesPerColumnFill: 'row',
          slidesPerGroup: 5,
          spaceBetween: 5,
          freeMode: true,
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            640: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            1020: {
              slidesPerView: 5,
              slidesPerGroup: 5,
            }
          }
        });
        window.addEventListener('resize', function () {
          swiper
        });
      });
    
  //SEARCH PAGE
    if (window.location.href.indexOf('/search') > -1) {
        if($('.boost-pfs-search-total-result strong')[0].innerText == 0){
          $('.search--page#preezie-widget-div-id').show();
          PREEZIE_GUIDE.render([
            {
              guideKey: 'PRE-d38fde64-3dc0-498b-36c4-08d94b096290',
              version: '1.0.0',
              renderTo: 'preezie-widget-div-id'
            }
          ]);  
        }
        else {
          $('.search--page#preezie-widget-div-id').hide();
        }
      
    }

  //VIDEO COLLECTION PAGE
      if (window.location.href.indexOf('/dalstrong-films') > -1) {
        $('.video-thumb').each(function(){
          $(this).click(function(){
            if ($(this).data('videoId') != ''){
              if ($(this).data('videoType') == 'youtube') {
                $('#videoModal .video-wrapper').html('<iframe src="//www.youtube.com/embed/' + $(this).data('videoId') + '?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
              }
              if ($(this).data('videoType') == 'vimeo') {
                $('#videoModal .video-wrapper').html('<iframe src="//player.vimeo.com/video/' + $(this).data('videoId') + '?color={{ settings.color_button | remove: "#" }}&byline=0&portrait=0&badge=0" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
              }
            }
            else {
              $('#videoModal .video-wrapper').html('<iframe src="//www.youtube.com/embed/_9VUPq3SxOc?rel=0&showinfo=0&vq=720" width="850" height="480" frameborder="0" allowfullscreen></iframe>')
            }

            $('#videoModal').fadeIn();

          })
        });

        $('#video-modal-close').click(function(){
          $('#videoModal .video-wrapper').html('');
          $('#videoModal').fadeOut();
        });

        window.onclick = function(event) {
          if (event.target == $('#videoModal')[0]) {
            $('#videoModal .video-wrapper').html('');
            $('#videoModal').fadeOut();
          }
        }
      }

  // BLOG ARTICLE PAGE - For table of content and mobile subcription form display
    if (window.location.href.indexOf('/blogs/')  > -1 ){
      const join = document.querySelector(".show_form")
      const form = document.querySelector(".mobile_subcribe_now")

      if(join){
        join.addEventListener('click', ()=>{
        form.classList.toggle("active")
      })
      }
      
      if(document.getElementById("table")){
        
        const x = Array.from(document.getElementById("table").children)

        var newlistDiv = document.getElementById("new_table")
        var newlist = "<ol>"
        x.forEach(function (y, i) {
          var section = parseInt(i) + 1
          newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + "</a></li>"
        })
        newlist += "</ol>"

        newlistDiv.innerHTML = newlist
      }

		if(document.getElementById("table")){
        
          const x = Array.from(document.getElementById("table").children)

          var newlistDiv = document.getElementById("mobile_table")
          var newlist = "<ol>"
          x.forEach(function (y, i) {
            var section = parseInt(i) + 1
            newlist += "<li><a class ='smooth_scroll' href = '#section" + section + "'>" + y.innerText + "</a></li>"
          })
          newlist += "</ol>"

          newlistDiv.innerHTML = newlist
        }
      
    }
    
  //COMPARE SECTION - HOMEPAGE
    if($('.compare-section-home')) {
      $(".compare-section-home .btn.compare-product").each(function() {
        $(this).on('click', function() {

          $(this).attr({'disabled': true}).text('Selected');
          $(this).parents('div.compare-page-item').addClass('selected-product');

          
          //CHECK IF SELECTED IS MORE THAN 1
          if($('.compare-section-home .selected-product').length > 1) {

            //POPULATE OVERLAY WITH SELECTED ITEM
            $('.compare-section-home .selected-product').each(function(){
              let selectedProducts = '<div class="selected-products-item"><span class="unselect-item">&#9587;</span><div class="selected-products-item-image">';
              selectedProducts += $(this).find('.compare-page-image img').prop("outerHTML") + '</div>';
              selectedProducts += '<div class="selected-products-item-details">' + $(this).find('.compare-page-details p').prop("outerHTML") + '</div></div></div>';
              $('.compare-section-home .selected-products').append(selectedProducts);
            })
            
            if($('.compare-section-home .selected-product').length == 2) {
              let addMoreProduct = '<button id="add-more-product"><span>+</span>ADD COMPARE</button>';
              $('.compare-section-home .selected-products').append(addMoreProduct);

              $('.compare-section-home #add-more-product').on('click', function(){
                $('#compare-product-selected').animate({
                  top: 50,
                  opacity: 0
                }, 400).hide(600);
                $('.compare-section-home .selected-products').html('');
              });
            }
            //SHOW OVERLAY
            $('#compare-product-selected').show().animate({
              top: 0,
              opacity: 1
            }, 500);
            
            //CLICK UNSELECT ITEM
            $(".selected-products-item .unselect-item").each(function(index) {
              
              $(this).on('click', function() {
                $('.compare-section-home .selected-product .btn.compare-product').eq(index).removeAttr('disabled').text('Compare');
                $('.compare-section-home .selected-product').eq(index).removeClass('selected-product');
               
                $('#compare-product-selected').animate({
                  top: 50,
                  opacity: 0
                }, 400).hide(600);

                $('.compare-section-home .selected-products').html('');

              });
              
            });
          }
        });
        
      });
      $(window).on('load', function(){
        $('.compare-section-home .compare-product-list').slideDown(500);
      });
      $('.compare-section-home #compare-products-btn').on('click', function(){
        $(this).addClass('btn--loading');
        let productsToCompare = [];
        $('.compare-section-home .selected-product').each(function() {
          productsToCompare.push($(this).data('product'));
        });
        localStorage.setItem("compare__products", JSON.stringify(productsToCompare));
        window.location.replace("/pages/compare");
      });
    }
    
    $('.megamenu .site-nav__dropdown-link:not(.site-nav__dropdown-link--top-level)').mouseover(function() {
        var collectionContent = '', activeMenu = $(this);
        
        function getCollection(content, activeMenu) {
          
          $.each(content.products, function(key,value) {
            var customTitle = '', customTitleMultiple = ' single-title';
            value.title.split('|').forEach(function (item, index) {
              if(index == 0){
                customTitle = '<span class="product-main-title">' + item + '</span>';
              }
            })
            if(value.title.split('|').length > 1){
              customTitleMultiple = ' multiple-title'; 
            }
            if(key < 4) {
              collectionContent = collectionContent + '<a href="/products/' + value.handle + '" class="site-nav__dropdown-content"><div class="site-nav__dropdown-content-image"><img alt="' + value.title + '" src="' + value.images[0].src + '"></img></div><div class="site-nav__dropdown-content-meta' + customTitleMultiple + '">' + customTitle + '</div></a>';
            }
          });
          collectionContent = collectionContent + '<a href="' + activeMenu.attr('href') + '" class="site-nav__dropdown-content"><div class="site-nav__dropdown-content-view-all"> View All </div></a>';
          $('div.site-nav__dropdown-container').remove();
          activeMenu.after('<div class="site-nav__dropdown-container hide">' + collectionContent + '</div>');
          $('div.site-nav__dropdown-container').animate({opacity: 1, 'marginTop':'0px'}, 600).removeClass('hide');
        }
        $.get(activeMenu.attr('href') + '/products.json?limit=4', function(data) { getCollection(data, activeMenu) })
    });
    $('.site-nav--is-megamenu .site-nav__link').hover(function(){
      $('div.site-nav__dropdown-container').remove();
    });
    $('.site-nav__dropdown.megamenu .grid').hover(function(){
      $('div.site-nav__dropdown-container').fadeOut();
    });
    $('.site-nav__dropdown.megamenu .page-width').hover(function(){
      $('div.site-nav__dropdown-container').fadeOut();
    });

    $(window).on('load', function(){
      $(window).scroll(function() {
        if($("#gfp_shopper_toolbar").length){
          $('.site-header-sticky .site-header--stuck').css('top', '20px');
          $('.site-header-sticky :not(.site-header--stuck)').css('top', '0px');
          $('.sticky__AddToCart').css('top', '90px'); 
        }
      })
      $('.list__view .grid-product__content').hover(
        function() {
          console.log($(this).find('.list__view_actions '));
          $(this).find('.list__view_actions').animate( { "opacity": "show", bottom:"5"} , 500 );
          //$(this).find('.list__view_actions').animate({'top' : '50%'},'fast');
        },
        function() {
          //$(this).find('.list__view_actions').animate({'top' : '-20%'},'fast');
          $(this).find('.list__view_actions').animate( { "opacity": "hide", bottom:"-20"} , 500 );
        }
      )
    }) 

  //PRE-ORDER - CART TEMPLATE CUSTOMIZATION
    Handlebars.registerHelper('ifEquals', function(arg1, arg2) {
      return (arg1 == arg2) ? (this) : !(this);
    });
    Handlebars.registerHelper('ifIncludes', function(arg1, arg2) {
      return (arg1.includes(arg2)) ? (this) : !(this) 
    });

})(theme.jQuery); 

// Mute all videos on the website
function mutePage() {
    var elems = document.querySelectorAll("video, iframe");

    [].forEach.call(elems, function(elem) { muteMe(elem); });
}

// Hide product price in COD collection

if (window.location.href === 'https://www.dalstrong.co.uk/collections/call-of-duty') {
    document.body.classList.add("call-of-duty");
}
if (window.location.href.indexOf("collections/boxing-day-collection") > -1) {
  document.body.classList.add("boxing-day-collection");
}